
export enum PricingLinks {
  EN = 'https://bkbn.com/pricing',
  FR = 'https://bkbn.com/fr/tarifs',
  DE = 'https://bkbn.com/de/preise',
  ES = 'https://bkbn.com/es/precios',
  NL = 'https://bkbn.com/nl/prijzen',
  ALL_PURPOSE = 'https://bkbn.com/pricing'
}
